var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConnectWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1744_3527)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 2.5625C2.6225 2.5625 0.6875 4.4975 0.6875 6.875V18.125C0.6875 20.5025 2.6225 22.4375 5 22.4375H20C22.3775 22.4375 24.3125 20.5025 24.3125 18.125V6.875C24.3125 4.4975 22.3775 2.5625 20 2.5625H5ZM5 3.6875H20C21.5656 3.6875 22.8689 4.82188 23.1351 6.3125H1.86487C2.13112 4.82188 3.43437 3.6875 5 3.6875ZM1.8125 7.4375H23.1875V10.0625H1.8125V7.4375ZM1.8125 11.1875H23.1875V18.125C23.1875 19.8819 21.7569 21.3125 20 21.3125H5C3.24312 21.3125 1.8125 19.8819 1.8125 18.125V11.1875ZM4.0625 17.5625C3.75125 17.5625 3.5 17.8138 3.5 18.125C3.5 18.4362 3.75125 18.6875 4.0625 18.6875H9.6875C9.99875 18.6875 10.25 18.4362 10.25 18.125C10.25 17.8138 9.99875 17.5625 9.6875 17.5625H4.0625ZM13.4375 17.5625C13.1263 17.5625 12.875 17.8138 12.875 18.125C12.875 18.4362 13.1263 18.6875 13.4375 18.6875H15.3125C15.6237 18.6875 15.875 18.4362 15.875 18.125C15.875 17.8138 15.6237 17.5625 15.3125 17.5625H13.4375Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1744_3527"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectWallet);
export default __webpack_public_path__ + "static/media/connect-wallet.2cb905b22ab7e5a7c4ee536fd227e082.svg";
export { ForwardRef as ReactComponent };